/**
 * Tiny event bus for the global notification bell sheet.
 * Allows toasts, links, or anywhere in the app to open the unified
 * notification overlay without prop drilling or routing.
 */

const OPEN_EVENT = 'lov:open-notifications';

export const openNotificationSheet = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_EVENT));
};

export const onOpenNotificationSheet = (handler: () => void) => {
  if (typeof window === 'undefined') return () => {};
  const listener = () => handler();
  window.addEventListener(OPEN_EVENT, listener);
  return () => window.removeEventListener(OPEN_EVENT, listener);
};
